export class UrlHelper {
  static getQueryParamValueByKey(url: string, key: string): string {
    const urlObj: URL = new URL(url);
    return urlObj.searchParams.get(key) ?? '';
  }
}
